import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import useRestaurantMenu from "../utils/useRestaurantMenu"
import ItemList from "./ItemList"
import Shimmer from "./Shimmer"
import RestaurantCategory from "./RestaurantCategory"

const RestaurantMenu = () => {
  const { resId } = useParams()
  const resMenu = useRestaurantMenu(resId)
  const [showItem, setShowItem] = useState(0)
  const [toggle,setToggle]=useState(0)
  console.log("resMenu: ",resMenu)
  const menu =
    resMenu?.data?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter(
      (x) =>
        x?.card?.card?.["@type"] ==
        "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory"
    )
  console.log(menu)

  
const text=resMenu?.data?.cards[0]?.card?.card?.text;
//console.log("text",text)
  return (
    <div className="items-center m-5 min-h-full dark:bg-slate-900">

    <span className="ml-96 bg-lime-200 shadow-2xl p-2 w-6/12 rounded shadow-lg mb-"> {text}</span>
      {
        /* {menu[1]?.card?.card?.title} */
      
        menu?.map((item,index) => {
          return (
        <RestaurantCategory item={item} showItem={showItem==index?true:false} setShowItem={()=>setShowItem(index)} />
          )
        })
      }
    </div>
  )
}
export default RestaurantMenu
